import { LOGOUT_URL } from '../../constants/ROUTECONSTANTS';

import setUserDetails from '../setUserDetails/setUserDetails';

export const clearCookies = (cookieNames = []) => {
  cookieNames.forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.wallstreetenglish.com; path=/;`;
  });
};

/**
 * To logout and redirect to NSE app
 */
export const appLogout = () => {
  localStorage.clear();
  clearCookies(['AccessToken', 'UserId', 'InCenter', 'RedirectToDashboard']);
  window.location.href = LOGOUT_URL;
};

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
  return undefined;
};

/**
 * To set authorization data
 * @param {context} initialLoadingContext
 * @param {context} notificationContext
 * @param {context} loaderContext
 */
const setAuthData = (initialLoadingContext, notificationContext, loaderContext) => {
  const accessToken = getCookie('AccessToken');
  const userId = getCookie('UserId');

  if (accessToken && userId) {
    localStorage.clear();
    localStorage.setItem('Auth', accessToken);
    localStorage.setItem('InCenter', getCookie('InCenter') || '');
    localStorage.setItem('RedirectToDashboard', getCookie('RedirectToDashboard') || '');

    clearCookies(['AccessToken', 'UserId', 'InCenter', 'RedirectToDashboard']);

    setUserDetails(userId, initialLoadingContext, notificationContext, loaderContext);
  } else if (localStorage.getItem('Auth') && localStorage.getItem('UserState')) {
    initialLoadingContext.setInitialLoadingHandler(true);
  } else if (!localStorage.getItem('Auth')) {
    appLogout();
  }
};

/**
 * To get authorize state
 * @param {context} initialLoadingContext
 * @param {context} notificationContext
 * @param {context} loaderContext
 * @returns {boolean}
 */
export const isAuthorized = (initialLoadingContext, notificationContext, loaderContext) => {
  setAuthData(initialLoadingContext, notificationContext, loaderContext);
  return !!localStorage.getItem('Auth');
};
